import { render } from "./ContactsEntityDetails.vue?vue&type=template&id=4240600b&scoped=true"
import script from "./ContactsEntityDetails.vue?vue&type=script&lang=js"
export * from "./ContactsEntityDetails.vue?vue&type=script&lang=js"

import "./ContactsEntityDetails.vue?vue&type=style&index=0&id=4240600b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4240600b"]])

export default __exports__